// extracted by mini-css-extract-plugin
export default {"taskList_information":"InformationAboutLackContent_taskList_information__KOw7K"};